import { render, staticRenderFns } from "./AvChartPie.vue?vue&type=template&id=09484d68"
import script from "./AvChartPie.vue?vue&type=script&lang=ts"
export * from "./AvChartPie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports